import { combineReducers } from 'redux';
import { commonReducer, ICommonState } from './modules/common';
import { gamesReducer, IGamesState } from './modules/games';
import { IPermissionState, permissionReducer } from './modules/permission';
import { studioReducer, IStudioState } from './modules/studio';

// 整个应用的store都放在此处，类似vue store
export interface IRootState {
  common: ICommonState;
  games: IGamesState;
  studio: IStudioState;
  permission: IPermissionState;
}

export const combinedReducers = combineReducers<IRootState | undefined>({
  common: commonReducer,
  games: gamesReducer,
  studio: studioReducer,
  permission: permissionReducer,
});
